import EquityMarketAdminPanel from 'modules/trading/pages/EquityMarketAdminPanel';
import { EquityMarketAdminPanelProvider } from '../pages/EquityMarketAdminPanel/context/EquityMarketAdminPanelContext';

const EquityMarketAdminPanelContainer = () => (
  <EquityMarketAdminPanelProvider>
    <EquityMarketAdminPanel />
  </EquityMarketAdminPanelProvider>
);

export default EquityMarketAdminPanelContainer;
